"use client";

import { useEffect, useMemo } from "react";
import type { Photo } from "@/lib/immich/types";

/**
 * Preload the previous and next photo's display URL so keyboard/swipe nav
 * feels instant. No-op on the server.
 */
export function useAdjacentPreload(
  photos: readonly Photo[],
  index: number,
): void {
  const adjacent = useMemo(
    () =>
      [index - 1, index + 1]
        .filter((i) => i >= 0 && i < photos.length)
        .map((i) => photos[i]!.displayUrl),
    [index, photos],
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const imgs = adjacent.map((url) => {
      const img = new Image();
      img.src = url;
      return img;
    });
    return () => {
      imgs.length = 0;
    };
  }, [adjacent]);
}
